import React from 'react';
import { FIGMA_SHARE_HINT, FIGMA_HELP_URL, FIGMA_PASSWORD_HINT } from '../../utils/figmaLinkCheck';

// One-line sharing guidance shown under every Aero Figma link input.
function FigmaShareHint({ className = 'ut-create-hint', withPassword = false }) {
  return (
    <>
      <div className={className}>
        {FIGMA_SHARE_HINT}{' '}
        <a href={FIGMA_HELP_URL} target="_blank" rel="noopener noreferrer">How to share a prototype</a>
      </div>
      {withPassword && <div className={className}>{FIGMA_PASSWORD_HINT}</div>}
    </>
  );
}

export default FigmaShareHint;
